export const selectCurrentCars = state => state.cars.current;

export const selectDayCars = state => state.cars.day;

export const selectAllCars = state => state.cars.records;

export const selectBookingRecords = state => state.cars.booking;

export const selectLoading = state => state.cars.isLoading;

export const selectIsAllCars404 = state => state.cars.isAllCars404;

export const selectError = state => state.cars.error;

export const selectDate = state => state.cars.date;

export const selectPercent = state => state.cars.loadPercent;

export const selectCarsForHours = state => state.cars.forHours;

export const selectQueryMonth = state => state.cars.queryMonth;

export const selectMonthlyLoad = state => state.cars.monthlyLoad;

export const selectWorkHours = state => state.cars.workHours;

export const selectWorkHoursForCurrentDay = state =>
  state.cars.workHoursForCurrentDay;

export const selectLastSetDate = state => state.cars.lastSetDate;

export const selectNewCars = state => state.cars.newCars;

export const selectPaymentStatistic = state => state.cars.paymentStatistic;

export const selectLoadingForCalendar = state =>
  state.cars.isLoadingForCalendar;

export const selectLoadingCarsByDay = state => state.cars.isLoadingCarsByDay;

export const selectCurrentCarsLoading = state =>
  state.cars.isCurrentCarsLoading;

export const selectIsPaymentStatisticLoading = state =>
  state.cars.isPaymentStatisticLoading;

export const selectPeriodCars = state => state.cars.periodCars;

export const selectStatistics = state => state.cars.statistics;

export const selectSelectedMonth = state => state.cars.selectedMonth;
